export const CTABS = {
  BLOCKED: 'Blocked',
  ALLOWED: 'Allowed'
}
